/* Rareva: scroll-driven motion for content pages.
   Marks content blocks inside each section for a staggered reveal,
   draws hairlines, settles hero headlines and images, counts up stats.

   Rules that keep it safe:
   - A block taller than ~90% of the viewport is never revealed as one
     unit; it is split into its children (recursively, up to 5 levels),
     so a long Terms/Care/Education body never sits invisible.
   - Reveal triggers the moment any part of a block enters the viewport
     (threshold 0), with a small bottom margin so it is not visible yet.
   - Anything already on screen at load reveals immediately.
   - Nothing is hidden until <html>.rv-motion is set (no JS = no hiding);
     prefers-reduced-motion disables everything.
   - Safety valve: a throttled scroll/resize check reveals any block whose
     top has entered the viewport, in case the observer misses it. */
(function () {
  'use strict';
  if (window.__rvMotion) return;
  window.__rvMotion = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var SKIP = { STYLE: 1, SCRIPT: 1, LINK: 1, TEMPLATE: 1, NOSCRIPT: 1 };
  var vh = window.innerHeight || 800;
  var TALL = vh * 0.9;

  function ok(el) {
    return el && el.nodeType === 1 && !SKIP[el.tagName] && !el.closest('details');
  }

  function collect(el, out, depth) {
    if (!ok(el)) return;
    var h = el.getBoundingClientRect().height;
    var kids = [];
    for (var i = 0; i < el.children.length; i++) if (ok(el.children[i])) kids.push(el.children[i]);
    if (h > TALL && kids.length && depth < 5) {
      for (var k = 0; k < kids.length; k++) collect(kids[k], out, depth + 1);
      return;
    }
    if (h < 2 && kids.length === 0) return;
    out.push(el);
  }

  function mark() {
    var main = document.getElementById('MainContent');
    if (!main) return [];
    var sections = main.querySelectorAll('.shopify-section');
    var items = [];
    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      if (sec.hasAttribute('data-rv-done')) continue;
      sec.setAttribute('data-rv-done', '1');
      var picked = [];
      var explicit = sec.querySelectorAll('[data-rv-reveal]');
      if (explicit.length) {
        for (var e = 0; e < explicit.length; e++) picked.push(explicit[e]);
      } else {
        var lvl1 = sec.children;
        for (var a = 0; a < lvl1.length; a++) {
          if (!ok(lvl1[a])) continue;
          var kids = lvl1[a].children, got = 0;
          for (var b = 0; b < kids.length; b++) {
            if (!ok(kids[b])) continue;
            collect(kids[b], picked, 0); got++;
          }
          if (!got) collect(lvl1[a], picked, 0);
        }
      }
      for (var p = 0; p < picked.length; p++) {
        var el = picked[p];
        if (el.getAttribute('data-rv-reveal') === 'done') continue;
        el.setAttribute('data-rv-reveal', 'done');
        el.style.setProperty('--rv-d', Math.min(p, 7) * 80 + 'ms');
        items.push(el);
      }
    }
    var heads = main.querySelectorAll('h1');
    for (var h = 0; h < heads.length; h++) if (!heads[h].hasAttribute('data-rv-head')) { heads[h].setAttribute('data-rv-head', ''); items.push(heads[h]); }
    var lines = main.querySelectorAll('.rv-edu__line, .rv-contact__rule, .hp-orn .ln');
    for (var l = 0; l < lines.length; l++) if (!lines[l].hasAttribute('data-rv-line')) { lines[l].setAttribute('data-rv-line', ''); items.push(lines[l]); }
    var figs = main.querySelectorAll('.rv-edu__fig, .rv-contact__map, .rv-sh__img, .about-hero__image-wrapper, .about-story__image-wrapper');
    for (var f = 0; f < figs.length; f++) if (!figs[f].hasAttribute('data-rv-img')) { figs[f].setAttribute('data-rv-img', ''); items.push(figs[f]); }
    return items;
  }

  function countUp(el) {
    var txt = (el.textContent || '').trim();
    var m = txt.match(/^([^0-9]*)([0-9][0-9,\.]*)([^0-9]*)$/);
    if (!m) return;
    var num = parseFloat(m[2].replace(/,/g, ''));
    if (isNaN(num) || num === 0) return;
    var dec = (m[2].split('.')[1] || '').length;
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      var v = num * e;
      el.textContent = m[1] + v.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + m[3];
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var pending = [];

  function show(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    if (el.hasAttribute('data-rv-count') && !el.__rvCounted) { el.__rvCounted = true; countUp(el); }
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      io.unobserve(entries[i].target);
      show(entries[i].target);
    }
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });

  /* Safety valve: on scroll/resize, reveal anything whose top is on screen. */
  var tick = null;
  function sweep() {
    tick = null;
    var h = window.innerHeight || vh;
    var keep = [];
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      if (el.classList.contains('is-in')) continue;
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.96 && r.bottom > -h) { io.unobserve(el); show(el); }
      else keep.push(el);
    }
    pending = keep;
  }
  function onScroll() { if (!tick) tick = requestAnimationFrame(sweep); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function run() {
    root.classList.add('rv-motion');
    var items = mark();
    var h = window.innerHeight || vh;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.top < h * 0.94 && r.bottom > 0) {
        (function (el) { requestAnimationFrame(function () { show(el); }); })(items[i]);
      } else if (r.bottom <= 0) {
        show(items[i]);
      } else {
        pending.push(items[i]);
        io.observe(items[i]);
      }
    }
    var stats = document.querySelectorAll('.rc-page [class*="stat"] strong, .rc-page [class*="stat__value"], .rc-page [class*="stat-value"], .rv-contact__stat b');
    for (var s = 0; s < stats.length; s++) if (!stats[s].hasAttribute('data-rv-count')) { stats[s].setAttribute('data-rv-count', ''); if (stats[s].classList.contains('is-in')) countUp(stats[s]); }
    var btns = document.querySelectorAll('.rv-edu__btn--primary, .rv-contact__btn, .rv-pol__btn--primary, .hp-btn.gold, .about-cta__btn--primary');
    for (var b = 0; b < btns.length; b++) btns[b].classList.add('rv-sheen');
    setTimeout(sweep, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
